var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonGenericV2',{attrs:{"text":_vm.buttonText},on:{"click":_vm.goTo}})}
var staticRenderFns = []

export { render, staticRenderFns }